import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";
import Utils from "@/mixins/Utils";

const ADMIN_USER = 'admin/user';
const LOCK_USER = '/lockUser';
const COMPANY = 'company';

export default {
    mixins: [SessionApi, Utils],
    methods: {
        async getUsers(type) {
            const url = `${baseURL}${ADMIN_USER}`
            const response = await this.httpSession().get(url,{params: {type}})
            console.debug('[USERS][getUsers] list:', response.data)
            return response.data;
        },

        async getUser(userId) {
            console.debug('[USERS][getUser] request userId', userId)
            const url = `${baseURL}${ADMIN_USER}/${userId}`
            const response = await this.httpSession().get(url)
            console.debug('[USERS][getUser] :', response.data)
            return response.data;
        },

        async getUsersByCompanyId() {
            const companyId = this.loadCompanyId()
            console.debug('[USERS][getUsersByCompanyId] request companyId', companyId)
            const url = `${baseURL}${COMPANY}/${companyId}/user`
            const response = await this.httpSession().get(url)
            console.debug('[USERS][getUsersByCompanyId] :', response.data)
            return response.data;
        },

        async createUser(data) {
            const companyId = this.loadCompanyId()
            console.debug('[USERS][createUser] request data', data)
            const url = `${baseURL}${COMPANY}/${companyId}/user`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[USERS][createUser] :', response)
            return response.data
        },

        async updateUser(data) {
            const companyId = this.loadCompanyId()
            console.debug('[USERS][updateUser] request data', data)
            const url = `${baseURL}${COMPANY}/${companyId}/user`
            const response = await this.httpSession().put(url, {...data})
            console.debug('[USERS][updateUser] :', response)
            return response.data
        },

        async deleteUser(userId) {
            const companyId = this.loadCompanyId()
            const url = `${baseURL}${COMPANY}/${companyId}/user/${userId}`
            console.debug('[USERS][deleteUser] request userId', userId)
            const response = await this.httpSession().delete(url)
            console.debug('[USERS][deleteUser] :', response)
            return response.data
        },

        async createSuperUser(data) {
            console.debug('[ADMIN_USERS][createSuperUser] request data', data)
            const url = `${baseURL}${ADMIN_USER}`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[ADMIN_USERS][createSuperUser] :', response)
            return response.data
        },

        async updateSuperUser(data) {
            console.debug('[ADMIN_USERS][updateSuperUser] request data', data)
            const url = `${baseURL}${ADMIN_USER}`
            const response = await this.httpSession().put(url, {...data})
            console.debug('[ADMIN_USERS][updateSuperUser] :', response)
            return response.data
        },

        async deleteSuperUser(userId) {
            const url = `${baseURL}${ADMIN_USER}/${userId}`
            console.debug('[ADMIN_USERS][deleteSuperUser] request userId', userId)
            const response = await this.httpSession().delete(url)
            console.debug('[ADMIN_USERS][deleteSuperUser] :', response)
            return response.data
        },

        async lockUser(data) {
            const url = `${baseURL}${ADMIN_USER}${LOCK_USER}`
            console.debug('[USERS][lockUser] request data', data)
            const response = await this.httpSession().post(url, {...data})
            console.debug('[USERS][lockUser] :', response)
            return response.data
        },
    },
};
